// src/App.js
import React from "react";
import { Route, Routes, Navigate } from "react-router-dom";
import { useAuth } from "./pages/Home1"; // Adjust path if necessary

// --- Import Page/Layout Components ---
// Public Pages
import Home from "./pages/Home"; // Your Login Page component
import Error from "./pages/Error"; // Your 404 Error page

// Protected Pages/Components
import BulkSms from "./pages/BulkSms";
import SentMessages from "./pages/SentMessages";

// Remove if BulkSms3 is obsolete:
import BulkSms3 from "./pages/BulkSms3";

// --- Import Route Wrapper ---
import ProtectedRoute from "./components/ProtectedRoute"; // Adjust path if necessary
import PhoneBook from "./pages/PhoneBook";
import DraftSms from "./pages/DraftSms";
import LoadVoucher from "./pages/LoadVoucher";
import TransactionHistory from "./pages/TransactionHistory";
import BuySmsOnline from "./pages/BuySmsOnline";
import Register from "./pages/Register";
import HomePage from "./pages/HomePage";
import CreditUser from "./pages/CreditUser";
import ManageMembers from "./pages/ManageMembers";
import GlobalMessageHistory from "./pages/GlobalMessageHistory"; // Adjust path if necessary
import AllTransactions from "./pages/AllTransactions";
import MessageStats from "./pages/MessageStats";

export default function App() {
  // Get authentication status from the context
  const { isLoggedIn } = useAuth();

  return (
    <Routes>
      {/* ======================== */}
      {/*      Public Routes       */}
      {/* ======================== */}
      {/* Login Route */}
      <Route
        path='/login'
        element={
          // If already logged in, redirect to the main protected page ('/compose')
          isLoggedIn ? <Navigate to='/compose' replace /> : <Home />
        }
      />
      {/* You could add other public routes here if needed */}
      <Route path='/register' element={<Register />} />
      <Route path='/home-page' element={<HomePage />} />
      {/* e.g., <Route path="/register" element={<RegisterPage />} /> */}
      {/* e.g., <Route path="/about" element={<AboutPage />} /> */}
      {/* ======================== */}
      {/*     Protected Routes     */}
      {/* ======================== */}
      {/* Wrap all protected routes within the ProtectedRoute component */}
      {/* If the user is not logged in, ProtectedRoute will redirect to /login */}
      <Route element={<ProtectedRoute />}>
        {/* --- Default Protected Route --- */}
        {/* If a logged-in user visits '/', redirect them to '/compose' */}
        <Route path='/' element={<Navigate to='/compose' replace />} />

        {/* --- Main Application Routes --- */}
        <Route path='/compose' element={<BulkSms />} />
        <Route path='/sentmessage' element={<SentMessages />} />
        <Route path='/messagehistory' element={<BulkSms3 />} />
        <Route path='/sms' element={<Home />} />
        <Route path='/manage-phonebook' element={<PhoneBook />} />
        <Route path='/draft-sms' element={<DraftSms />} />
        <Route path='/load-voucher' element={<LoadVoucher />} />
        <Route path='/transaction-history' element={<TransactionHistory />} />
        <Route path='/buy-sms-online' element={<BuySmsOnline />} />
        <Route path='/credit-user' element={<CreditUser />} />
        <Route path='/manage-members' element={<ManageMembers />} />
        <Route
          path='/global-message-history'
          element={<GlobalMessageHistory />}
        />
        <Route path='/all-transactions' element={<AllTransactions />} />
        <Route path='/message-stats' element={<MessageStats />} />

        {/* If BulkSms3 is still needed, uncomment and place here */}
        {/* <Route path="/message-history" element={<BulkSms3 />} /> */}

        {/* Add any other routes that require the user to be logged in */}
        {/* <Route path="/profile" element={<UserProfile />} /> */}
        {/* <Route path="/settings" element={<SettingsPage />} /> */}
      </Route>{" "}
      {/* End of Protected Routes */}
      {/* ======================== */}
      {/*      Fallback Route      */}
      {/* ======================== */}
      {/* Catch-all route for any paths not matched above (404 Not Found) */}
      {/* You might want the Error page itself to be public */}
      <Route path='*' element={<Error />} />
    </Routes>
  );
}
